import "./style.css";
const menuHandler = () => {
    const headerContainer = document.querySelector("header .header--container");
    const menu = headerContainer?.querySelector(".menu");
    const menuItemsList = menu?.querySelectorAll("ul li:not(:has(.access))");
    const mobileBtn = headerContainer?.querySelector(".menu--toggle");
    window.addEventListener('scroll', function () {
        const stickyElement = document.querySelector('.header');
        const scrollPosition = window.scrollY || document.documentElement.scrollTop;
        if (scrollPosition > 700) {
            stickyElement.classList.add("sticky");
        }
        else {
            stickyElement.classList.remove("sticky");
        }
    });
    mobileBtn?.addEventListener("click", () => {
        mobileBtn?.classList.toggle("active");
        if (mobileBtn?.classList.contains("active")) {
            menuItemsList?.forEach((item) => {
                item.addEventListener("click", () => {
                    mobileBtn?.classList.remove("active");
                });
            });
        }
    });
};
menuHandler();
